import { useEffect, useState } from "react";
import { storage, auth } from "../firebase";
import { ref, listAll, getDownloadURL } from "firebase/storage";
import FileUpload from './FileUpload';

function ServicesClient() {
    const [files, setFiles] = useState([]);
    const [givenFiles, setGivenFiles] = useState([]);
    useEffect(() => {
        if (!auth.currentUser) return;
        const listUserFiles = async () => {
            try {
                const userFilesRef = ref(storage, auth.currentUser.uid + "/");
                const res = await listAll(userFilesRef);

                const urls = await Promise.all(
                    res.items.map(async (itemRef) => {
                        const url = await getDownloadURL(itemRef);
                        return { name: itemRef.name, url };
                    })
                );
                setFiles(urls);
            } catch (error) {
                console.error("Error listing files: ", error);
            }
        };
        listUserFiles();
    }, []);

    useEffect(() => {
        if (!auth.currentUser) return;
        const listUserFiles = async () => {
            try {
                const userFilesRef = ref(storage, auth.currentUser.uid + "/response/");
                const res = await listAll(userFilesRef);

                const urls = await Promise.all(
                    res.items.map(async (itemRef) => {
                        const url = await getDownloadURL(itemRef);
                        return { name: itemRef.name, url };
                    })
                );
                setGivenFiles(urls);
            } catch (error) {
                console.error("Error listing files: ", error);
            }
        };
        listUserFiles();
    }, []);

    return (
        <section id="services" className="services-area services-eight">
            <div className="section-title-five">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="content">
                                <h6>Service de partage de documents</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    {files.length === 0 ? (
                        <p>No files uploaded yet.</p>
                    ) : (
                        files.map((file) => (
                            <div className="col-lg-4 col-md-6" key={file.name}>
                                <div className="single-services">
                                    <div className="service-icon">
                                        <i className="lni lni-folder"></i>
                                    </div>
                                    <div className="service-content">
                                        <h4>{file.name}</h4>
                                        <a
                                            download={file.name}
                                            href={file.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-primary mt-2"
                                        >
                                            Télécharger
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
            <FileUpload />
            <div className="section-title-five">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="content">
                                <h6>Documents partagés avec vous</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    {files.length === 0 ? (
                        <p>No files uploaded yet.</p>
                    ) : (
                        givenFiles.map((file) => (
                            <div className="col-lg-4 col-md-6" key={file.name}>
                                <div className="single-services">
                                    <div className="service-icon">
                                        <i className="lni lni-folder"></i>
                                    </div>
                                    <div className="service-content">
                                        <h4>{file.name}</h4>
                                        <a
                                            download={file.name}
                                            href={file.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-primary mt-2"
                                        >
                                            Télécharger
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>

        </section>

    );
}

export default ServicesClient;
